/* eslint-disable @typescript-eslint/no-explicit-any */
import { ReportState } from '@/store/reports/types';
import { MutationTree } from 'vuex';

export const mutations: MutationTree<ReportState> = {
  SET_DATA(state, data: any): void {
    state.data = data;
  }
};
